var map = {
	"./apidays-2022-snapshot-1.jpg": "a03c",
	"./apidays-2022-snapshot-2.jpg": "53d4",
	"./apidays-2022-snapshot-charm-1.jpg": "013c",
	"./apidays-2022-snapshot-gary-1.jpg": "ace2",
	"./apidays-2022-snapshot-richard-1.jpg": "6f89",
	"./apidays-2022-snapshot-trevor-1.jpg": "d21d",
	"./apidays-hongkong-2022-agenda-0824.png": "72f9",
	"./apidays-hongkong-2022-agenda-0825.png": "0259",
	"./apidays-hongkong-2022-logo.png": "e9b8",
	"./apidays-hongkong-2022-participants.jpg": "66f1",
	"./apidays-hongkong-2022-video-cover.jpg": "8921"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2bac";